import type { FC } from 'react';
import { memo, useEffect, useRef, useState } from 'react';
import { searchNoResult } from '@images';
import SearchInput from '../components/SearchInput';
// import SearchCategory from '../components/SearchCategory';
import SearchProducts from '../components/SearchProducts';
import SearchQueriesList from '../components/SearchQueriesList';
import EmptyBanner from '@components/EmptyBanner';
import { Link } from '@compat/router';
import type { HeaderSearchSettings } from '..';
import './index.scss';
import LoadingPage from '@components/LoadingPage';
import SearchTips from '../components/SearchTips';

const HeaderSearchMobile: FC<HeaderSearchSettings> = ({
  searchHeader,
  searchValue,
  searchInputOnKeyUp,
  searchInputOnBlur,
  searchInputOnClick,
  clearInput,
  isLoading,
  showSearchResult,
  searchData,
  isSearchPage,
  // onSearchBtnClick,
  searchQueries,
  onChangeLink,
  onRemove,
  tips
}) => {
  const searchBlockRef = useRef<HTMLDivElement | null>(null);
  const [searchBlockHeight, setSearchBlockHeight] = useState(128);

  useEffect(() => {
    const el = searchBlockRef.current;
    if (el && typeof ResizeObserver !== 'undefined') {
      const observer = new ResizeObserver(([entry]) => {
        const height =
          entry.borderBoxSize?.[0]?.blockSize ??
          entry.target.getBoundingClientRect().height;
        setSearchBlockHeight(height);
      });
      observer.observe(el);
      return () => observer.disconnect();
    }
  }, []);

  const translateYValue = `translateY(${searchBlockHeight + 4}px)`;
  return (
    <div className='search-mobile'>
      <SearchInput
        id='header-search-input'
        compact
        value={searchValue}
        onChange={searchHeader}
        onFocus={searchInputOnClick}
        onKeyUp={searchInputOnKeyUp}
        clearInput={clearInput}
      />
      {showSearchResult && !isSearchPage && (
        <div className='search-mobile__dark-bg' />
      )}
      <div className={'search-mobile-result'}>
        <div
          ref={searchBlockRef}
          style={
            showSearchResult
              ? {
                  transform: 'translateY(0)',
                  visibility: 'visible',
                  opacity: 1,
                  zIndex: 982,
                  position: 'fixed',
                  left: 0,
                  top: 0
                }
              : {
                  position: 'fixed',
                  zIndex: 982,
                  visibility: 'hidden',
                  opacity: 0,
                  left: 0,
                  top: 0,
                  transform: 'translateY(-100%)'
                }
          }
          className={'search-mobile-result__header'}
        >
          <div className=''>
            <div className='flex items-center w-full'>
              <SearchInput
                value={searchValue}
                onKeyUp={searchInputOnKeyUp}
                onChange={searchHeader}
                // onSearchBtnClick={onSearchBtnClick}
                clearInput={clearInput}
                compact
              />
              <div
                className='search-mobile__cancel'
                onClick={searchInputOnBlur}
              >
                Отмена
              </div>
            </div>

            {showSearchResult && (
              <div className='mt-2'>
                {searchValue ? (
                  !!tips?.length &&
                  showSearchResult && <SearchTips tips={tips} />
                ) : searchQueries?.length > 0 ? (
                  <SearchQueriesList
                    searchQueries={searchQueries}
                    onChangeLink={onChangeLink}
                    onRemove={onRemove}
                  />
                ) : null}
              </div>
            )}
          </div>
        </div>
        <div
          style={
            showSearchResult && !isSearchPage
              ? {
                  visibility: 'visible',
                  transform: translateYValue,
                  opacity: 1,
                  position: 'fixed',
                  zIndex: 982,
                  top: 0,
                  left: 0
                }
              : {
                  visibility: 'hidden',
                  opacity: 0,
                  transform: 'translateY(100%)',
                  position: 'fixed',
                  top: 0,
                  left: 0,
                  zIndex: 982
                }
          }
          className={'search-mobile-result__content'}
        >
          <div>
            {/* {searchData.categories?.length > 0 && (
              <SearchCategory categories={searchData.categories} />
            )} */}
            {searchData.products?.length > 0 && (
              <SearchProducts products={searchData.products} />
            )}
            {searchData.products.length === 0 &&
            searchData.categories.length === 0 ? (
              isLoading ? (
                <LoadingPage className='min-h-0 py-6 mt-0' />
              ) : (
                <EmptyBanner
                  title='Поиск не дал результатов'
                  description='К сожалению то, что Вы искали не найдено или не существует'
                  img={searchNoResult}
                  link='/catalog'
                  height='120'
                />
              )
            ) : searchValue ? (
              <Link
                to={`/search?query=${searchValue}`}
                className='mt-5 flex w-full items-center h-11 text-sm justify-center transition-colors mx-auto hover:bg-[var(--dark-red)] hover:text-white border border-solid rounded-lg'
              >
                Показать больше товаров
              </Link>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(HeaderSearchMobile);

// { /* <div className='search-data search-data--no-result'>
//             <img src={searchNoResult} alt='Поиск не дал результатов' />
//             <div className='title'> Поиск не дал результатов </div>
//             <div className='subtitle'> К сожалению то, что Вы искали не найдено или не существует</div>
//           </div> */ }
